import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useMemo, useState } from 'react';
import { ClientCafe } from '../../apiTypes';
import DataTable, { Column } from '../../components/DataTable';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';

import EditClientGroup from './EditClientGroup';

type Row = DbDocument<ClientCafe>;

const ClientGroups = () => {
  const { worker, clientGroups } = useCafe();
  const { lang } = useLocale();
  const [client, setClient] = useState<DbDocument<ClientCafe> | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const columns: Column<Row>[] = useMemo(
    () => [
      {
        name: 'name',
        title: t.name[lang],
        align: 'left',
        render: (r: Row) => r.name,
      },
      {
        name: 'discount',
        title: t.discount[lang],
        align: 'left',
        render: (r: Row) => `${r.personalDiscount}%`,
      },
      {
        name: 'edit',
        title: '',
        align: 'right',
        render: (r: Row) => (
          <IconButton
            onClick={() => {
              setClient(r);
              setIsOpen(true);
            }}
            disabled={!worker?.credentials.add_and_edit_clients}
          >
            <Edit />
          </IconButton>
        ),
      },
    ],
    [lang, worker?.credentials.add_and_edit_clients]
  );

  return (
    <>
      <DataTable
        columns={columns}
        rows={clientGroups || []}
        actionButton={
          <PrimaryButton
            onClick={() => setIsOpen(true)}
            variant="contained"
            disabled={!worker?.credentials.add_and_edit_clients}
          >
            {t.add_client_group[lang]}
          </PrimaryButton>
        }
        onRowClick={(r) => setClient(r)}
        dataTestIdPrefix="clientGroup"
      />

      {isOpen && (
        <EditClientGroup
          client={client}
          onClose={() => {
            setIsOpen(false);
            setClient(null);
          }}
        />
      )}
    </>
  );
};

export default ClientGroups;
